export type ManageUserMFA = {
  userId: string;
  mfaEnabled: boolean;
  userMfaType: number;
  isMfaVerified: boolean;
};

export type VerifyOTP = {
  verificationCode: string;
  mfaId: string;
  authType: number;
};

export type GenerateOTPPayload = {
  userId: string;
  mfaType: number;
};

export type GenerateOTPResponse = {
  mfaId: string;
  isSuccess: boolean;
  errors?: Record<string, string>;
};

export type VerifyOTPResponse = {
  isSuccess: boolean;
  isValid: boolean;
  valid?: boolean;
  error?: string;
  error_description?: string;
  errors?: Record<string, string>;
  useId: string;
};

export type SetUpTotp = {
  userId: string;
  projectKey: string;
  OtpUploadtype: number;
};

export type VerifyTotpSetup = {
  code: string;
  userId: string;
};

export interface IMFAConfiguration {
  enabled: boolean;
  allowedMethods: number[];
  requireMfaForAllUsers: boolean;
  mfaRequiredRoles: string[];
  mfaExemptRoles: string[];
  allowUserOptOut: boolean;
  allowBackupCodes: boolean;
  backupCodesCount: number;
}

export const isMfaMethodAvailable = (
  config: IMFAConfiguration | undefined,
  method: number
): boolean => Boolean(config?.enabled && config.allowedMethods?.includes(method));

export type DisableUserMfaRequest = {
  userId: string;
};

export type DisableUserMfaResponse = {
  errors?: Record<string, string>;
  isSuccess: boolean;
};
